import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SupportedCurrency } from '@core/models';
import { endpoints, environment } from '@environment';
import { Observable } from 'rxjs';
import { suppressGlobalErrorFeedback } from '@core/interceptors';

@Injectable({ providedIn: 'root' })
export class SupportedCurrenciesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/${endpoints.v1.supportedCurrencies}`;

  getActive(): Observable<SupportedCurrency[]> {
    return this.http.get<SupportedCurrency[]>(this.baseUrl, { context: suppressGlobalErrorFeedback() });
  }
}
